// extracted by mini-css-extract-plugin
export var calendarView = "_mb-0";